import React from 'react';
import { Container, Row, Col, Image, ListGroup } from 'react-bootstrap';
import Blog5 from '../Components/img/buildingrelation.jpg'; // Using the image from the blog

const BuildingHealthyRelationships = () => {
  return (
    <Container className="py-5">
      <Row className="align-items-center">
        <Col md={6}>
        <h2 className="text-dark">Building Healthy Relationships</h2>
          <p className="text-muted">
            Relationships have a significant impact on our mental and emotional well-being. Strong and positive connections 
            with others help reduce stress, improve happiness, and create a supportive environment for personal growth.
          </p>
          <p className="text-muted">
            Whether it's family, friends, or colleagues, fostering **healthy relationships** ensures better communication, mutual respect, and emotional support.
          </p>
          <Image src={Blog5} alt="Building Healthy Relationships" fluid className="rounded shadow" />
        </Col>
        <Col md={6}>
        

          <h5 className="text-dark mt-4">Tips for Building Healthy Relationships:</h5>
          <ListGroup variant="flush" className="mt-3">
            <ListGroup.Item>✅ <strong>Effective Communication:</strong> Open and honest conversations strengthen trust.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Active Listening:</strong> Paying attention and understanding others' perspectives builds deeper connections.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Respect & Boundaries:</strong> Healthy relationships require mutual respect and personal space.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Quality Time:</strong> Spending time together fosters emotional bonding.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Handling Conflicts Positively:</strong> Resolving disagreements with patience and empathy strengthens relationships.</ListGroup.Item>
          </ListGroup>

          <p className="text-muted mt-3">
            Developing and maintaining **strong relationships** is a key factor in leading a happy and fulfilling life. 
            Learn more about improving **social connections, emotional intelligence, and interpersonal skills** for a healthier life.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default BuildingHealthyRelationships;
